import { render, staticRenderFns } from "./List.vue?vue&type=template&id=19e52cdc&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"
import style0 from "./List.vue?vue&type=style&index=0&id=19e52cdc&prod&lang=css"
import style1 from "./List.vue?vue&type=style&index=1&id=19e52cdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e52cdc",
  null
  
)

export default component.exports